import { DOM } from '../core/dom';
import { Slider } from '../core/slider';

export namespace FreelancersPathToRemote {
  export function onload(): void {
    Slider.setup('freelancers-path-to-remote-slides', 'freelancer').onChange(idx => {
      DOM.removeClass('#freelancers-path-to-remote > .gigs-steps > .gigs-step', 'active');
      DOM.byId(`path-to-remote-${idx}`).classList.add('active');
    });
  }
}